import styled from 'styled-components';

export const TabsStyle = styled.div`
  .ant-tabs-tab {
    padding: 6px 20px;
    font-weight: 500;
    margin: 0;
  }
  .ant-tabs-ink-bar {
    border-bottom: 4px solid #0090f0;
  }
`;
